import { Field as BaseField } from "@base-ui/react/field";
import { Input as BaseInput } from "@base-ui/react/input";
import type { ComponentProps } from "react";
import { cn } from "../utils";

export function Field({
  className,
  ...props
}: ComponentProps<typeof BaseField.Root>) {
  return (
    <BaseField.Root className={cn("flex flex-col gap-1.5", className)} {...props} />
  );
}

export function FieldLabel({
  className,
  ...props
}: ComponentProps<typeof BaseField.Label>) {
  return (
    <BaseField.Label
      className={cn("text-2xs font-medium tracking-wide text-ink-secondary", className)}
      {...props}
    />
  );
}

export function FieldError({
  className,
  ...props
}: ComponentProps<typeof BaseField.Error>) {
  return (
    <BaseField.Error
      className={cn("text-2xs text-danger", className)}
      {...props}
    />
  );
}

export function FieldDescription({
  className,
  ...props
}: ComponentProps<typeof BaseField.Description>) {
  return (
    <BaseField.Description
      className={cn("text-2xs text-ink-muted", className)}
      {...props}
    />
  );
}

export const inputClassName = cn(
  "h-8 w-full rounded-control border border-line-strong bg-surface-raised px-2.5",
  "text-[0.8125rem] text-ink placeholder:text-ink-faint shadow-raised",
  "transition-[border-color,box-shadow] duration-150 ease-swift",
  "hover:border-ink-faint",
  "focus:border-ember focus:outline-none focus:ring-2 focus:ring-ember/25",
  "disabled:pointer-events-none disabled:opacity-50",
  "[&::-webkit-search-cancel-button]:appearance-none",
  "[&::-webkit-search-decoration]:appearance-none",
);

export function Input({
  className,
  ...props
}: ComponentProps<typeof BaseInput>) {
  return <BaseInput className={cn(inputClassName, className)} {...props} />;
}
